<template>
	<v-container fluid>
    <v-layout row wrap>
      <v-flex md12>
        <call-center></call-center>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import callCenter from '@/components/reports/call_center/Callers';

export default {
  components: {
    callCenter,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/call_center/Index.vue